var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-wrapper d-flex align-items-center justify-content-center"},[_c('audio',{ref:"recordingPlayer",attrs:{"autoplay":"","controls":""}},[_c('source',{attrs:{"src":_vm.audioSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }